import {
    Component,
    inject,
    Inject
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialogActions, MatDialogContent,
  MatDialogRef, MatDialogTitle
} from '@angular/material/dialog';
import {DialogBoxBouton, DialogBoxBoutonTypeeEnum, DialogBoxConfiguration, DialogBoxData} from "./dialog-box-configuration";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";



@Component({
  selector: 'lib-pegase-dialog-box',
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatIcon
  ],
  templateUrl: './dialog-box.component.html',
  standalone: true,
})
export class DialogBoxComponent {
    private dialogRef = inject(MatDialogRef<DialogBoxComponent>);
    private dialogConfiguration = inject<DialogBoxConfiguration>(MAT_DIALOG_DATA);

    data: DialogBoxData;
    buttons: Array<DialogBoxBouton>;

    buttonTypes=DialogBoxBoutonTypeeEnum;

    constructor() {
      console.log('dialogConfiguration', this.dialogConfiguration);

      this.data = this.dialogConfiguration.data;
        if(this.data.title== null) {
            this.data.title = 'Confirmez votre action';
        }
        this.buttons = this.dialogConfiguration.buttons;
    }

    onClick(button: DialogBoxBouton) {
        this.dialogRef.close(button);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
